var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "diagram conncection",
    id: "diagram_conncection"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,7h4a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H18a1,1,0,0,0-1,1V3H13a1,1,0,0,0-1,1v7H9V9A1,1,0,0,0,8,8H2A1,1,0,0,0,1,9v6a1,1,0,0,0,1,1H8a1,1,0,0,0,1-1V13h3v7a1,1,0,0,0,1,1h4v1a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H18a1,1,0,0,0-1,1v1H14V13h3v1a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V10a1,1,0,0,0-1-1H18a1,1,0,0,0-1,1v1H14V5h3V6A1,1,0,0,0,18,7ZM7,14H3V10H7Zm12,5h2v2H19Zm0-8h2v2H19Zm0-8h2V5H19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.c9d29a3ce4cd7b1382ad69f17a161eff.svg";
export { ForwardRef as ReactComponent };